import Component from '@glimmer/component';
import { action } from '@ember/object';
import MiscUtils from 'mewe/utils/miscellaneous-utils';


export default class WalletSuccess extends Component { 

  @action
  copyToClipBoard() {
    MiscUtils.copyToClipboard(this.args.transactionHash);
  }
}